<template>
    <info
        v-c-tooltip="{
            content: sanitizedTooltip,
            allowHtml: true,
            popperOptions: {
                positionFixed: true,
            },
        }"
    />
</template>

<script setup>
import Info from '@/../icons/Info.vue';
import { computed } from 'vue';

const props = defineProps({
    tooltip: String,
});

const sanitizedTooltip = computed(() => {
    return props.tooltip?.replaceAll('\\n', '<br/>');
});
</script>
